import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import sentGAEvent from '@/ga';
import AudioCompressWorkListRender from './children/AudioCompressWorkListRender';
import AudioCompressWorkOperationRender from './children/AudioCompressWorkOperationRender';
import Process from '@/components/common/process/Process';
import Utils from '@/utils';

import '@/assets/audioCompress.less';

class AudioCompressWorkFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      format: 'mp3',
      quality: '256',
    };
  }

  handleCompress = () => {
    sentGAEvent({
      category: 'audio_compress_output',
      action: 'audio_compress_output_click',
    });
    let flag = Utils.handleVideoEditorTimes('28AC');
    if (flag) {
      return false;
    }
    const { format, quality } = this.state;
    this.props.handleSubmit(format, quality);
  };

  handleFormat = (format) => {
    this.setState({ format });
  };

  handleQuality = (quality) => {
    this.setState({ quality });
  };

  render() {
    const { t } = this.props;
    return (
      <div className='workplace-container'>
        <AudioCompressWorkListRender
          audioCompressList={this.props.audioCompressList}
          deleteAudioCompressItem={this.props.deleteAudioCompressItem}
          uploadProps={this.props.uploadProps}
          handleStopUpload={this.props.handleStopUpload}
          compressing={this.props.compressing}
        />
        <AudioCompressWorkOperationRender
          compressing={this.props.compressing}
          handleCompress={this.handleCompress}
          handleQuality={this.handleQuality}
          handleFormat={this.handleFormat}
        />
        {this.props.compressing ? (
          <div className='step-con'>
            <div className='step-header'>
              <span className='step-num active'>
                <span>3</span>
              </span>
              <div className='process-cont'>
                <div>
                  <Process
                    visible
                    theme='light'
                    showProcessText
                    processText={t('Compressing')}
                    hideCancelText
                    cancelProcessCallBack={this.props.cancelProcessCallBack}
                    uploadNumber={this.props.audioCompressList.length}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withTranslation(['audioCompress'])(AudioCompressWorkFunction);
